import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Button, useTheme } from "@mui/material";

interface CloseButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const CloseButton = ({
  onClick,
  disabled = false,
}: CloseButtonProps) => {
  const { colors, customSpacing, radius, customFontWeight } = useTheme();
  const { t } = useResource();

  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: 80,
        borderColor: colors.border.primary,
        backgroundColor: colors.background.primary,
        color: colors.text.primary,
        borderRadius: radius.full,
        p: `${customSpacing.sm} ${customSpacing.lg}`,
        textTransform: "none",
        fontWeight: customFontWeight.bold,
        "&:hover": {
          borderColor: colors.border.secondary,
        },
        "&:disabled": {
          opacity: 0.6,
        },
      }}
    >
      {t(Resources.Common.Close)}
    </Button>
  );
};
